<template>
  <v-row>
    <v-col cols="12" sm="12" md="10">
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="4" class="pt-xs-5 pt-sm-0 pt-md-0">
          <v-select
            v-model="status"
            item-text="title"
            item-value="status"
            label="Trạng Thái"
            :items="allBillStatus"
            single-line
            filled
            dense
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="4" class="pt-xs-5 pt-sm-0 pt-md-0"
          ><v-autocomplete
            :items="allPaymentType"
            v-model="payment"
            item-text="title"
            item-value="status"
            clear-icon="mdi-close"
            label="Hình Thức Thanh Toán"
            deletable-chips
            single-line
            filled
            dense
          ></v-autocomplete
        ></v-col>
        <v-col cols="12" sm="12" md="4" class="pt-xs-5 pt-sm-0 pt-md-0">
          <div>
            <DateRangePicker
              label="Thời gian"
              :date-range.sync="dateRange"
              single-line
              filled
            /></div
        ></v-col>
      </v-row>
      <v-text-field
        v-if="false"
        v-model="tags"
        clear-icon="mdi-close"
        clearable
        label="Lọc Tìm kiếm theo tags"
        dense
        :required="false"
      ></v-text-field>
      <autocomplete-staff
        v-if="false"
        v-model="requestor"
        item-text="name"
        item-value="id"
        deletable-chips
        clear-icon="mdi-close"
        clearable
        chips
        small-chips
        label="Lọc Người lập hóa đơn"
        dense
        :required="false"
      ></autocomplete-staff>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="2"
      class="d-flex pt-5 pt-sm-0 pt-md-0 d-flex justify-sm-end justify-md-end justify-end"
      ><v-btn
        class="elevation-0 ma-2 py-5"
        dark
        color="amber dark-1"
        @click="onFilterChanged"
      >
        <v-icon class="" left>filter_alt</v-icon>Lọc
      </v-btn></v-col
    >
  </v-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import AutocompleteStaff from '@/components/basic/input/AutocompleteStaff'
import DateRangePicker from '@/components/basic/picker/DateRangeIOSPicker'

export default {
  components: { AutocompleteStaff, DateRangePicker },
  props: {
    defaultFilters: Object,
  },
  data: () => ({
    tags: '',
    query: '',
    status: '',
    state: '',
    payment: '',
    title: '',
    date_gt: '',
    date_lt: '',
    requestor: null,
    dateRange: [],
  }),
  computed: {
    ...mapState('constant', [
      'leadStatus',
      'leadState',
      'paymentTypes',
      'billStatus',
    ]),
    ...mapGetters('app', ['department']),
    allBillStatus() {
      return [
        {
          title: 'Tất Cả',
          status: '',
        },
        ...this.billStatus,
      ]
    },
    allLeadState() {
      return [
        {
          title: 'Tất cả trạng thái',
          status: '',
        },
        ...this.leadState,
      ]
    },
    allPaymentType() {
      return [
        {
          title: 'Các hình thức thanh toán',
          status: '',
        },
        ...this.paymentTypes,
      ]
    },
  },
  async created() {
    await this.fetchLeads({ department: this.department.id })
  },
  methods: {
    ...mapActions('leads', ['fetchLeads']),
    onFilterChanged() {
      this.date_gt = ''
      this.date_lt = ''
      if (this.dateRange.length > 1) {
        this.date_gt = moment(this.dateRange[0], 'DD/MM/YYYY').toISOString()
        this.date_lt = moment(this.dateRange[1], 'DD/MM/YYYY')
          .add(1, 'd')
          .toISOString()
      } else if (this.dateRange.length > 0) {
        this.date_gt = moment(this.dateRange[0], 'DD/MM/YYYY').toISOString()
        this.date_lt = moment(this.dateRange[0], 'DD/MM/YYYY')
          .add(1, 'd')
          .toISOString()
      }
      this.$emit('onFilterChanged', {
        title_contains: this.title,
        status: this.status,
        state: this.state,
        paymentType: this.payment,
        staff: this.requestor,
        tags_contains: this.tags,
        date_gt: this.date_gt,
        date_lt: this.date_lt,
      })
    },
  },
}
</script>
<style scoped>
.v-input--selection-controls,
.v-input__slot {
  margin: 0;
  padding: 0;
}
</style>
